import React, { Suspense } from 'react'
import { Switch, Route, NotFound, AuthRoute } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import PageSkeleton from './components/PageSkeleton/PageSkeleton'
import usePlaceSystemHealthStatusOverlay from './components/hooks/usePlaceSystemStatusOverlay'
import EnglandMapsPage from './EnglandMapsPage/EnglandMapsPage'
import { PlacesAppProvider } from './components/PlacesApp/PlacesAppContext'

// Dynamically load components to reduce bundle size
// https://reactjs.org/docs/react-api.html#reactlazy

const PlacesApp = React.lazy(() => import('./components/PlacesApp/PlacesApp'))

function App() {
  usePlaceSystemHealthStatusOverlay()
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageSkeleton />}>
        <Switch>
          <Route
            exact
            path="/"
            render={(props) => (
              <PlacesAppProvider>
                <PlacesApp {...props} />
              </PlacesAppProvider>
            )}
          />
          <AuthRoute exact path="/mapp" component={EnglandMapsPage} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  )
}
export default App
